import { ReactNode } from "react";

export type OnboardingStatus = "todo" | "in_progress" | "done";

export type OnboardingStepKey =
  | "company_context"
  | "add_suppliers"
  | "data_labels"
  | "data_pools"
  | "add_processes"
  | "import_privacy_policy"
  | "import_collection_notice"
  | "control_selection"
  | "assurance_task_scheduling";

export interface OnboardingStep {
  key: OnboardingStepKey;
  title: string;
  description?: string;
  dependsOn?: OnboardingStepKey[];
}

export const STARTER_ONBOARDING_STEPS: OnboardingStep[] = [
  {
    key: "company_context",
    title: "Company Context",
    description: "Enter your company details to get started.",
  },
  {
    key: "add_suppliers",
    title: "Add Suppliers",
    description: "Select your key suppliers to support your data governance.",
    dependsOn: ["company_context"],
  },
  {
    key: "add_processes",
    title: "Add Processes",
    description: "Select the suggested business processes that reflect how your business operates.",
    dependsOn: ["company_context", "add_suppliers"],
  },
  {
    key: "data_labels",
    title: "Data Labels",
    description: "Review suggested data labels and choose those most relevant to your business.",
    dependsOn: ["company_context", "add_suppliers", "add_processes"],
  },
  // {
  //   key: "data_pools",
  //   title: "Data Pools",
  //   description: "Review/confirm suggested data pools",
  //   dependsOn: ["company_context"],
  // },
  {
    key: "import_privacy_policy",
    title: "Import Privacy Policy",
    description: "Upload your Privacy Policy to document your commitments and requirements.",
  },
  {
    key: "import_collection_notice",
    title: "Import Collection Notice(s)",
    description: "Upload your notice(s) to record how information is collected and used.",
  },
  {
    key: "control_selection",
    title: "Control Selection",
    description: "Answer a few questions to confirm your current control coverage and document your current status.",
    // dependsOn: ["add_processes"],
  },
  {
    key: "assurance_task_scheduling",
    title: "Assurance Program",
    description: "Set up ongoing assurance tasks and choose your preferred review interval.",
    dependsOn: ["control_selection"],
  },
];
